import CareerPathJobDetails from './CareerPathJobDetails'
export default CareerPathJobDetails
